module.exports = __webpack_public_path__ + "static/digital-asia2-f7958c869cae156db33231f382906fe2.png";